module.exports = __webpack_public_path__ + "static/media/client-logo-26.c3a48587.jpg";